import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
interface ImageCarouselProps {
  images: string[];
}
export function ImageCarousel({
  images
}: ImageCarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const goToPrevious = () => {
    setCurrentIndex(prevIndex => prevIndex === 0 ? images.length - 1 : prevIndex - 1);
  };
  const goToNext = () => {
    setCurrentIndex(prevIndex => prevIndex === images.length - 1 ? 0 : prevIndex + 1);
  };
  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };
  return <div className="relative w-full max-w-5xl mx-auto" data-id="element-207">
      {/* Main Image */}
      <div className="relative aspect-video bg-gray-100 rounded-2xl overflow-hidden shadow-2xl" data-id="element-208">
        <img src={images[currentIndex]} alt={`Preview ${currentIndex + 1}`} className="w-full h-full object-contain" data-id="element-209" />

        {/* Navigation Arrows */}
        <button onClick={goToPrevious} className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-slate-900 p-3 rounded-full shadow-lg transition-all hover:scale-110" aria-label="Previous image" data-id="element-210">
          <ChevronLeft className="w-6 h-6" data-id="element-211" />
        </button>
        <button onClick={goToNext} className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-slate-900 p-3 rounded-full shadow-lg transition-all hover:scale-110" aria-label="Next image" data-id="element-212">
          <ChevronRight className="w-6 h-6" data-id="element-213" />
        </button>
      </div>

      {/* Dots Indicator */}
      <div className="flex justify-center gap-2 mt-6" data-id="element-214">
        {images.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className={`transition-all ${index === currentIndex ? 'w-8 h-3 bg-orange-500' : 'w-3 h-3 bg-gray-300 hover:bg-gray-400'} rounded-full`} aria-label={`Go to slide ${index + 1}`} data-id="element-215" />)}
      </div>

      {/* Counter */}
      <p className="text-center mt-4 text-gray-600 font-medium" data-id="element-216">
        {currentIndex + 1} / {images.length}
      </p>
    </div>;
}